import {
  Accordion, AccordionDetails, AccordionSummary, Backdrop, Box, CircularProgress,
  Container, Divider, FormControl, Grid, IconButton, InputAdornment, InputBase,
  InputLabel, MenuItem, Pagination, Paper, Select, Stack, Table, TableBody,
  TableContainer, TableHead, TableRow, TextField, Typography
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { IPays, StyledTableCell, tableStyle } from "../Pays/Pays";
import axios, { AxiosInstance } from "axios";
import { Fragment, useContext, useEffect, useState } from "react";
import { urlApi } from "../Pays/RowPays";
import TarificationRow from "./TarificationRow";
import Cookies from "universal-cookie";
import { DataRef } from "../../../../types/DataRef";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddtarifForms from "../../../forms/Tarif/AddtarifForms";
import { managerIdConstanteNumber } from "../../../../constants/Constants";
import UserInformation from "../../../../types/UserInformation";
import { Reducers } from "../../../../redux/reducers";
import { useSelector } from "react-redux";
import { tableColumnTittlesTarif, TarifInterface } from "./InterfaceTarification";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import TabSort from "../../../element/sort/TabSort";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ClearIcon from "@mui/icons-material/Clear";
import { SortType } from "../../../../types/AlertType";
import { IPeriodeCloture, SortParams } from "../../production/SaisieAgent";
import { loggoutUser } from "../../../../redux/actions/logginUser";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import CheckAttr from "../../../../utils/CheckAttr";
import { MediaQueryContext } from "../../../../utils/contextes/MediaQueryContext";

interface Bus {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
}
export interface IPaysSearch {
  id: number;
  libelle: string;
  created_at: string;
  updated_at: string;
  date_suppression: any;
  bus_tarif: Bus[];
}

export interface Itarif {
  id?: number;
  tarifheure: string;
  tarifacte: string;
  tarifformation: string;
  tarifheuredimanche: string;
  tarifformationdimanche: string;
  tarifactedimanche: string;
  date_debut: any;
  date_fin: any;
  operation_id: number;
  operation: {
    id: number;
    libelle: string;
    association_parametrage_id: number;
    EstHno: boolean;
    EstFormation: number;
    association_parametrage: {
      id: number;
      pays_id: number;
      bu_id: number;
      clients_id: number;
      pays: DataRef;
      bu: DataRef;
      client: DataRef;
    };
  };
}

interface FilterParams {
  socifact: string;
  codeGesco: string;
  operation: string;
  date_debut: string;
  date_fin?: string;
}

const initialFilter: FilterParams = {
  socifact: "",
  codeGesco: "",
  operation: "",
  date_debut: "",
  date_fin: "",
};

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const Tarification = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);
  
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();


  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );


  const [page, setPage] = useState<number>(1);
  const [rowPerPage, setRowPerPage] = useState(5);
  const [nb, setNb] = useState(0);
  const [loader, setLoader] = useState<boolean>(false);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<number | false>(false);

  const [dataTarif, setDataTarif] = useState<TarifInterface[]>([]);

  const [dataRefPaysBu, setDataRefPaysBu] = useState<IPays[]>([]);

  // Pour Recherche
  const [filter, setFilter] = useState<FilterParams>(initialFilter);
  const [articleSearch, setArticleSearch] = useState<string>("");

  // Pour Les Filtre Tarification qui on de Saisie Manager
  const [idArrayTarificationWithSm, setIdArrayTarificationWithSm] = useState<
    Number[]
  >([]);

  // Pour les Select
  const [existSocieteFactOnTarif, setExistSocieteFactOnTarif] = useState<
    DataRef[]
  >([]);
  const [existCodeGescoOnTarif, setExistCodeGescoOnTarif] = useState<DataRef[]>(
    []
  );
  const [existOperationOnTarif, setExistOperationOnTarif] = useState<DataRef[]>(
    []
  );

  // coloone
  const [sortedColumn, setSortedColumn] = useState<number>(0);
  const [columnToSort, setColumnToSort] = useState<SortParams | undefined>(
    undefined
  );

  // Date De Cloture
  const [allPeriodeClotured, setAllPeriodeClotured] = useState<
    IPeriodeCloture[]
  >([]);

  const setSortParams = (column: string, order: SortType) => {
    setColumnToSort({
      column,
      orderBy: order,
    });
  };

  const logger = useSelector<Reducers>(
    (state) => state.logger
  ) as UserInformation;

  const getArrayIdTarificationWithSm = () => {
    axios
      .get(`${urlApi}get/tarification/sm/periode`)
      .then((res) => {
        setIdArrayTarificationWithSm(res.data);
      })
      .finally(() => { });
  };

  const getPaginateTarif = () => {
    // Recuperer tous les Tarif par pagination
    setLoader(true);
    const data = {
      rowPerPage,
      articleSearch,
      page: page,
      filter,
      sortby: columnToSort,
    };

    http
      .post("get/tarification", data)
      .then((res) => {
        setDataTarif(res.data.data);
        setNb(res.data.total);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const ClickSearch = () => {
    setPage(1);
    getPaginateTarif();
  };

  useEffect(() => {
    getPaginateTarif();
  }, [page, filter, rowPerPage, columnToSort, refresh]);

  useEffect(() => {
    // Récupère les societe de facturation qui existe dans tarif
    http
      .get("tarification/get-exist-socifact")
      .then((res) => {
        Array.isArray(res?.data) && setExistSocieteFactOnTarif(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });

    // Recuperer Tous Les Periode Cloturé du Date Now
    http
      .post("saisie/manager/get-period-to-disable/quantities", {})
      .then((res) => {
        setAllPeriodeClotured(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const handleClose = () => {
    setOpenModal(false);
  };

  const reloadList = () => {
    setRefresh(!refresh);
  };

  const iconToUse = (id: number): JSX.Element => {
    let icon = <ArrowUpwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
    if (sortedColumn === id) {
      if (columnToSort && columnToSort.orderBy === "DESC") {
        icon = <ArrowDownwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
      }
    }

    return icon;
  };

  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;

    if (name === "socifact") {
      // Récupère les code gesco qui existe dans tarif
      http
        .get(`tarification/get-exist-codeGesco/${value}`)
        .then((res) => {
          Array.isArray(res?.data) && setExistCodeGescoOnTarif(res?.data);
        })
        .catch((error) => {
          console.log(error);
        });

      setFilter({
        ...filter,
        [name]: value,
        codeGesco: "",
        operation: "",
      });
    }

    if (name === "codeGesco") {
      // Récupère les code gesco qui existe dans tarif
      http
        .get(`tarification/get-exist-operation/${filter?.socifact}/${value}`)
        .then((res) => {
          Array.isArray(res?.data) && setExistOperationOnTarif(res?.data);
        })
        .catch((error) => {
          console.log(error);
        });

      setFilter({
        ...filter,
        [name]: value,
        operation: "",
      });
    }

    if (name === "operation") {
      setFilter({
        ...filter,
        [name]: value,
      });
    }

    if (name === "date_debut") {
      setFilter({
        ...filter,
        date_debut: value,
      });
    }
  };

  const resetFilter = () => {
    setFilter(initialFilter);
    setExistCodeGescoOnTarif([]);
    setExistOperationOnTarif([]);
    setColumnToSort(undefined);
    setSortedColumn(0);
    setArticleSearch("");
    reloadList();
  };

  const pagination: JSX.Element | boolean = !loader && (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowPerPage}
          onChange={(e) => {
            setRowPerPage(e.target.value as number);
            setPage(1);
          }}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {nb > rowPerPage && (
        <Pagination
          count={Math.ceil(nb / rowPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => setPage(value)}
        />
      )}
    </Stack>
  );

  return (
    <>
      <Container maxWidth="lg">
        {isDesktopOrLaptop ? (
          <Fragment>
            <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }} >
              <Grid item xs={6} sm={2} md={3.4} spacing={1.5} />
              <Grid item xs={1} sm={2} md={1.5}>
                <FormControl fullWidth>
                  <InputLabel id="socifact" color="warning" sx={{ mt: -1 }}>
                    Societe de facturation
                  </InputLabel>
                  <Select
                    labelId="socifact"
                    id="socifact"
                    name="socifact"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Societe de facturation"
                    value={filter?.socifact}
                    onChange={handleChangeFilter}
                  >
                    <MenuItem value={""} dense></MenuItem>
                    {existSocieteFactOnTarif.map((item) => (
                      <MenuItem value={item.id} dense>
                        {item.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={1.5} md={1.5}>
                <FormControl fullWidth>
                  <InputLabel id="codeGesco" color="warning" sx={{ mt: -1 }}>
                    Code gesco
                  </InputLabel>
                  <Select
                    labelId="codeGesco"
                    id="codeGesco"
                    name="codeGesco"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Code gesco"
                    value={filter?.codeGesco}
                    onChange={handleChangeFilter}
                  >
                    <MenuItem value={""} dense></MenuItem>
                    {existCodeGescoOnTarif.map((item) => (
                      <MenuItem value={item?.id} dense>
                        {item?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={1.5} md={1.5}>
                <FormControl fullWidth>
                  <InputLabel id="operation" color="warning" sx={{ mt: -1 }}>
                    Opération
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="operation"
                    name="operation"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Opération"
                    value={filter?.operation}
                    onChange={handleChangeFilter}
                  >
                    <MenuItem value={""} dense></MenuItem>
                    {existOperationOnTarif.map((item) => (
                      <MenuItem value={item?.id} dense>
                        {item?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={1.5} md={1.5}>
                <FormControl fullWidth>
                  <TextField
                    name="date_debut"
                    label="Date debut"
                    type="date"
                    color="warning"
                    sx={{ backgroundColor: "#fff", borderRadius: 1 }}
                    size="small"
                    value={filter?.date_debut}
                    onChange={handleChangeFilter}
                    InputLabelProps={{
                      shrink: true,
                      style: { color: "#fff", marginTop: -7 },
                    }}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={3} sm={2.5} md={2}>
                <Typography sx={{ display: "flex" }}>
                  <InputBase
                    sx={{ ml: 4, flex: 1, color: "white" }}
                    value={articleSearch}
                    placeholder="Article"
                    onChange={(e) => setArticleSearch(e.target.value)}
                    fullWidth
                  />
                  <Grid item xs={2}>
                    <IconButton
                      type="submit"
                      sx={{ p: "10px", color: "white" }}
                      aria-label="search"
                      onClick={ClickSearch}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs={1} sm={1.5} md={0.5}>
                    <IconButton
                      aria-label="refresh"
                      sx={{ color: "#fff", pt: 0.5 }}
                      onClick={() => resetFilter()}
                    >
                      <RefreshIcon sx={{ fontSize: 35 }} />
                    </IconButton>
                  </Grid>
                </Typography>
              </Grid>
            </Grid>

            <Box display="flex" justifyContent="left" mt={4}>
              {pagination}
            </Box>

            <TableContainer component={Paper} style={tableStyle}>
              <Table>
                <TableHead>
                  <TableRow>
                    {tableColumnTittlesTarif.map((column) => (
                      <TabSort
                        key={column.id}
                        column={column}
                        icon={iconToUse(column.id)}
                        sortedColumn={sortedColumn}
                        setSortParams={setSortParams}
                        setSortedColumn={setSortedColumn}
                      />
                    ))}
                    {logger?.profils?.id != managerIdConstanteNumber && (
                      <StyledTableCell align="center">Action</StyledTableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataTarif.map((row) => (
                    <TarificationRow
                      key={row?.id}
                      isDesktopOrLaptop={isDesktopOrLaptop}
                      http={http}
                      row={row}
                      dataRefPaysBu={dataRefPaysBu}
                      reloadList={reloadList}
                      expanded={expanded}
                      setExpanded={setExpanded}
                      allPeriodeClotured={allPeriodeClotured}
                    />
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box
              display="flex"
              justifyContent="right"
              mt={3}
              mr={6}
            >
              {pagination}
            </Box>
          </Fragment>
        ) : (
          <>
            <Box
              sx={{
                position: 'fixed',
                width: '95%',
                top: '10.32rem',
                pr: 1.5,
                pt: 2,
                bgcolor: '#080d24',
                zIndex: 1000
              }}
            >
              <Accordion>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Filtre
                </AccordionSummary>
                <AccordionDetails>
                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(filter?.socifact) && "Societe De Facturation"}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Societe De Facturation"
                      name="socifact"
                      value={filter?.socifact}
                      onChange={handleChangeFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {existSocieteFactOnTarif.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel
                      id="codeGesco"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(filter?.codeGesco) && "Code gesco"}
                    </InputLabel>
                    <Select
                      labelId="codeGesco"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Code gesco"
                      name="codeGesco"
                      value={filter?.codeGesco}
                      onChange={handleChangeFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {existCodeGescoOnTarif.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel
                      id="operation"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(filter?.operation) && "Opération"}
                    </InputLabel>
                    <Select
                      labelId="operation"
                      id="demo-simple-select"
                      size="small"
                      color="warning"
                      label="Opération"
                      name="operation"
                      value={filter?.operation}
                      onChange={handleChangeFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {existOperationOnTarif.map((item) => (
                        <MenuItem key={item?.id} value={item?.id} dense>
                          {item?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl fullWidth>
                    <TextField
                      name="date_debut"
                      label="Date debut"
                      type="date"
                      color="warning"
                      sx={{ borderRadius: 1, mt: 2.5 }}
                      size="small"
                      value={filter?.date_debut}
                      onChange={handleChangeFilter}
                      InputLabelProps={{
                        shrink: true,
                        style: { color: "#fff", marginTop: -7 },
                      }}
                    />
                  </FormControl>
                </AccordionDetails>
              </Accordion>

              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  display: { xs: "flex", sm: "none" },
                  bgcolor: '#fff',
                  borderRadius: 1,
                  mt: 1,
                  mb: 3
                }}
                placeholder="Chercher un article ..."
                size="small"
                fullWidth
                value={articleSearch}
                onChange={(e) => setArticleSearch(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => ClickSearch()}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton
                        aria-label="refresh"
                        onClick={() => resetFilter()}
                      >
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Typography>Liste des tarifs</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 2 }} />

              {(!loader && nb > rowPerPage) && (
                <Box display="flex" justifyContent="end">
                  <Pagination
                    count={Math.ceil(nb / rowPerPage)}
                    size="small"
                    color="standard"
                    sx={{ button: { color: "white" }, mb: 2 }}
                    showFirstButton={true}
                    showLastButton={true}
                    siblingCount={0}
                    boundaryCount={1}
                    defaultPage={page}
                    onChange={(event, value) => setPage(value)}
                  />
                </Box>)}
            </Box>

            <Box mt='12.5rem'>
              {dataTarif.map((row) => (
                <TarificationRow
                  key={row?.id}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  http={http}
                  row={row}
                  dataRefPaysBu={dataRefPaysBu}
                  reloadList={reloadList}
                  expanded={expanded}
                  setExpanded={setExpanded}
                  allPeriodeClotured={allPeriodeClotured}
                />
              ))}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>Lignes par page :</InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12
                  }}
                  value={rowPerPage}
                  onChange={(e) => setRowPerPage(e.target.value as number)}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}
      </Container>
      <OptionalWidthModal
        title="Ajouter un nouveau tarif"
        breackPoint="lg"
        onClose={handleClose}
        open={openModal}
      >
        <AddtarifForms
          dataRefPaysBu={dataRefPaysBu}
          getPaginateTarif={getPaginateTarif}
          onClose={handleClose}
        />
      </OptionalWidthModal>
      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </>
  );
};

export default Tarification;
